import { get } from 'lodash';
import {
  REQUEST_CREATE_FEE_NOTE,
  REQUEST_FEE_NOTES,
  REQUEST_LAWYER_FEE_NOTES,
  SET_CREATE_FEE_NOTE,
  SET_FEE_NOTES,
  SET_ALL_FEE_NOTES,
  REQUEST_CREATE_FEE_NOTE_COSTS,
  REQUEST_LAWYER_FEE_NOTES_BY_CLAIM_NUMBER,
  REQUEST_LAWYER_FEE_NOTES_BY_POLICY_NUMBER,
  REQUEST_LAWYER_FEE_NOTES_BY_REGISTRATION_NUMBER,
  REQUEST_UPDATE_FEE_NOTE_AMOUNT,
  REQUEST_UPDATE_FEE_NOTE,
  REQUEST_ADD_INVOICE_FEE_NOTE,
  REQUEST_UPDATE_INVOICE_FEE_NOTE,
  REQUEST_ALL_LAWYER_FEE_NOTES,
  REQUEST_UPDATE_FIRM_REFERENCE_MANAGER,
  REQUEST_REJECT_FEE_NOTE_LAWYER,
  REQUEST_GET_KPI_OVERDUE_INVOICE,
  REQUEST_SET_KPI_OVERDUE_INVOICE,
} from 'containers/LawyerFeeNote/constants';
import { FeeNote } from 'containers/LawyerFeeNote/typings';

export const requestAllFeeNotes = (page: number, pageSize: number) => ({
  type: REQUEST_FEE_NOTES,
  page,
  pageSize,
});

export const requestLawyerFeeNotes = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_LAWYER_FEE_NOTES,
  status,
  page,
  pageSize,
});
export const setFeeNotes = (feeNotes: any) => ({
  type: SET_FEE_NOTES,
  data: get(feeNotes, 'data.feeNotes'),
});
export const setFeeNotesSearch = (feeNotes: any) => ({
  type: SET_FEE_NOTES,
  data: feeNotes.data,
});
export const setAllFeeNotes = (feeNotes: any) => ({
  type: SET_ALL_FEE_NOTES,
  data: feeNotes.data,
});
export const setFeeNoteByClaimNumber = (feeNotes: any) => ({
  type: SET_FEE_NOTES,
  data: feeNotes,
});
export const setFeeNote = (feeNote: FeeNote) => ({
  type: SET_CREATE_FEE_NOTE,
  data: feeNote,
});

export const requestCreateFeeNote = (
  feeNote: FeeNote,
  successCallBack: Function,
) => ({
  type: REQUEST_CREATE_FEE_NOTE,
  feeNote,
  successCallBack,
});

export const requestFeeNoteCosts = (
  feeNote: FeeNote,
  successCallBack: Function,
) => ({
  type: REQUEST_CREATE_FEE_NOTE_COSTS,
  feeNote,
  successCallBack,
});

export const addFeeNote = (feeNote: FeeNote) => ({
  type: SET_CREATE_FEE_NOTE,
  data: feeNote,
});
export const requestFeeNotesByClaimNumb = (claimNumber: string) => {
  return {
    type: REQUEST_LAWYER_FEE_NOTES_BY_CLAIM_NUMBER,
    claimNumber,
  };
};

export const requestFeeNotesByPolicyNumber = (policyNumber: string) => {
  return {
    type: REQUEST_LAWYER_FEE_NOTES_BY_POLICY_NUMBER,
    policyNumber,
  };
};

export const requestFeeNotesByRegistrationNumber = (
  registrationNumber: string,
) => {
  return {
    type: REQUEST_LAWYER_FEE_NOTES_BY_REGISTRATION_NUMBER,
    registrationNumber,
  };
};

export const requestUpdateFeeNoteAmount = (
  payload: FeeNote,
  successCallBack: Function,
) => ({
  type: REQUEST_UPDATE_FEE_NOTE_AMOUNT,
  payload,
  successCallBack,
});

export const requestUpdateFeeNoteStatus = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_UPDATE_FEE_NOTE,
  payload,
  successCallBack,
});

export const requestAddInvoiceFeeNote = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_ADD_INVOICE_FEE_NOTE,
  payload,
  successCallBack,
});

export const requestUpdateInvoiceFeeNote = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_UPDATE_INVOICE_FEE_NOTE,
  payload,
  successCallBack,
});
export const requestAllLawyerFeeNotes = (status: any) => ({
  type: REQUEST_ALL_LAWYER_FEE_NOTES,
  status,
});

export const requestUpdateFirmReferenceManager = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_UPDATE_FIRM_REFERENCE_MANAGER,
  payload,
  successCallBack,
});

export const requestRejectFeeNoteLawyer = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_REJECT_FEE_NOTE_LAWYER,
  payload,
  successCallBack,
});

export const requestGetKpiOverdueInvoice = () => ({
  type: REQUEST_GET_KPI_OVERDUE_INVOICE,
});

export const requestSetKpiOverdueInvoice = (payload: any) => ({
  type: REQUEST_SET_KPI_OVERDUE_INVOICE,
  payload,
});
